if (!customElements.get('clear-input')) {

  class ClearInput extends HTMLElement {

    constructor() {
      super();

      // Options
      this.options = {
        hiddenClass: 'hidden'
      };

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions
        };
      }

      this.init();

    }

    init() {
      this.input = this.querySelector('[data-input]');
      this.reset = this.querySelector('[data-reset]');
      this.setInitState();
      // Handle reset click
      this.reset.addEventListener('click', () => {
        this.clearInput();
        this.hideReset();
      });
      // Handle typing
      this.input.addEventListener('keyup', () => {
        if(this.hasInput()) {
          this.showReset();
        } else {
          this.hideReset()
        }
      })
    }

    hasInput() {
      return this.input.value.length > 0 ? true : false;
    }

    clearInput() {
      this.input.value = '';
      this.input.focus();
    }

    showReset() {
      this.reset.classList.remove(this.options.hiddenClass);
    }

    hideReset() {
      this.reset.classList.add(this.options.hiddenClass);
    }

    setInitState() {
      if(this.hasInput()) {
        this.showReset();
      } else {
        this.hideReset();
      }
    }

  }

  window.ClearInput = ClearInput;

  customElements.define('clear-input', ClearInput);

}
